import { render, staticRenderFns } from "./PT.vue?vue&type=template&id=5e539296&scoped=true&"
import script from "./PT.vue?vue&type=script&lang=js&"
export * from "./PT.vue?vue&type=script&lang=js&"
import style0 from "./PT.vue?vue&type=style&index=0&id=5e539296&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e539296",
  null
  
)

export default component.exports